/** @format */

export function parseHtmlScripts(html?: string | null): {
  htmlWithoutScripts: string;
  scriptSources: string[];
} {
  if (!html || typeof html !== 'string') {
    return { htmlWithoutScripts: html || '', scriptSources: [] };
  }

  const doc = new DOMParser().parseFromString(html, 'text/html');
  const scriptSources: string[] = [];

  doc.querySelectorAll('script').forEach(script => {
    const src = script.getAttribute('src');
    if (src) {
      scriptSources.push(src);
    }
    script.remove();
  });

  return {
    htmlWithoutScripts: doc.body.innerHTML,
    scriptSources: [...new Set(scriptSources)]
  };
}
